import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Button from "components/Button";

const PrevNextWrapper = styled.div`
  bottom: 1.25rem;
  display: flex;
  justify-content: center;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  z-index: 2;

  ${({ theme }) => theme.mq.xl`
    display: none;
  `}
`;

const StyledButton = styled(Button)`
  filter: drop-shadow(0 0 0.25rem rgba(0, 0, 0, 0.25));
  margin: 0 1rem;
  width: 9rem;

  &:first-of-type {
    margin: 0 0.5rem 0 1rem;
  }

  &:last-of-type {
    margin: 0 1rem 0 0.5rem;
  }
`;

const SearchPrevNextButtons = ({ activeBusinessId, data, setActiveBusinessId }) => {
  // get the active businesses's index position
  const activeBusinessIndex = data?.vendorBusinesses?.data?.findIndex((business) => business.id === activeBusinessId);
  // get the first business id
  const firstMarkerId = data?.vendorBusinesses?.data?.[0]?.id;
  // get the last business id
  const lastMarkerId = data?.vendorBusinesses?.data?.[data?.vendorBusinesses?.pagination?.pageSize - 1]?.id;
  // get the previous business id
  const prevMarkerId = data?.vendorBusinesses?.data?.[activeBusinessIndex - 1]?.id;
  // get the previous business id
  const nextMarkerId = data?.vendorBusinesses?.data?.[activeBusinessIndex + 1]?.id;
  // clicked previous button
  const onClickPrev = () => setActiveBusinessId(prevMarkerId || firstMarkerId);
  // clicked next button
  const onClickNext = () => setActiveBusinessId(nextMarkerId || lastMarkerId);

  return (
    <PrevNextWrapper>
      <StyledButton outlineType="outline" outlineTransparent={false} onClick={onClickPrev} disabled={!prevMarkerId}>
        Previous
      </StyledButton>
      <StyledButton outlineType="outline" outlineTransparent={false} onClick={onClickNext} disabled={!nextMarkerId}>
        Next
      </StyledButton>
    </PrevNextWrapper>
  );
};

export default SearchPrevNextButtons;

SearchPrevNextButtons.propTypes = {
  activeBusinessId: PropTypes.string,
  data: PropTypes.object,
  setActiveBusinessId: PropTypes.func,
};

SearchPrevNextButtons.defaultProps = {
  activeBusinessId: undefined,
  data: undefined,
  setActiveBusinessId: () => {},
};
